import './styles.scss'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Marquee from 'react-fast-marquee'
import TimerPicker from 'Components/TimerPicker'
import { commonMethods } from 'Utils/commonMethods'
import ROUTE_STRINGS from 'Utils/Constants/RouteStrings'
import { ABOUT_US_ICON_URL } from 'Screens/YourNews/Utils'

const YourNewsHeader = ({ shortNewsItems = [], className = '' }) => {
  const history = useHistory()
  const { dateFormatBasedOnUser } = commonMethods
  const items = Array.isArray(shortNewsItems) ? shortNewsItems.filter((item) => item && (item.newsSubject || typeof item === 'string')) : []
  const [trendingNewsStyle, setTrendingNewsStyle] = useState({ width: '100%' })

  useEffect(() => {
    const navbar = document.querySelector('.navbar-nav')

    if (!navbar) return

    const updatePosition = () => {
      const rect = navbar.getBoundingClientRect()
      // 200px total horizontal space (100px left + 100px right)
      const widthWithPadding = Math.max(0, rect.width - 224)

      setTrendingNewsStyle({
        width: `${widthWithPadding}px`
      })
    }

    updatePosition()

    // Observe navbar changes
    const observer = new ResizeObserver(() => updatePosition())

    observer.observe(navbar)

    // Handle browser resizes
    window.addEventListener('resize', updatePosition)

    return () => {
      observer.disconnect()
      window.removeEventListener('resize', updatePosition)
    }
  }, [])

  const handleAboutUsClick = () => {
    history.push(ROUTE_STRINGS.aboutUs)
  }

  return (
    <header className={`your-news-header ${className}`.trim()} data-testid="your-news-header">
      <div className="your-news-header__datetime">
        <span className="your-news-header__date" data-testid="your-news-date">
          {dateFormatBasedOnUser()}
        </span>
        <span className="your-news-header__time">
          <TimerPicker testId="your-news-time-picker" />
        </span>
      </div>
      <div className="your-news-header__ticker-wrap">
        <div
          className={`for_trending_news ${!items.length ? 'trending-news-absent' : ''}`}
          data-testid="your-news-trending-news"
          style={{
            width: trendingNewsStyle.width
          }}
        >
          <div className="labaling">{items.length ? 'News :' : ''}</div>
          {items.length > 0 && (
            <Marquee pauseOnHover speed={27} className="marquee_main_div">
              <>
                {items.map((item, index) => {
                  const text = typeof item === 'string' ? item : item?.newsSubject || ''
                  const color = typeof item === 'string' ? undefined : item?.trendingNewsColour

                  if (!text) return null

                  return (
                    <React.Fragment key={index}>
                      <div className="marquee_tag">
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <div className="bullet_dot" />
                          <div style={{ color }} className={color === '#000000' ? 'coffeequotes-trending-news-color' : ''}>
                            {typeof item === 'string' ? <span>{text}</span> : <span dangerouslySetInnerHTML={{ __html: item?.newsSubject || '' }} />}
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  )
                })}
              </>
            </Marquee>
          )}
        </div>
      </div>
      <div className="your-news-header__about-nav" data-testid="your-news-about-nav">
        <img
          src={ABOUT_US_ICON_URL}
          alt="About CoffeeWeb"
          className="your-news-header__about-icon"
          onClick={handleAboutUsClick}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault()
              handleAboutUsClick()
            }
          }}
        />
      </div>
    </header>
  )
}

export default YourNewsHeader
